import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M8 1.334A6.67 6.67 0 0 0 3.413 3.18V2A.667.667 0 1 0 2.08 2v3a.667.667 0 0 0 .667.667h3a.667.667 0 0 0 0-1.333h-1.6A5.333 5.333 0 1 1 2.667 8a.667.667 0 0 0-1.334 0A6.667 6.667 0 1 0 8 1.334m0 4A.667.667 0 0 0 7.333 6v2A.667.667 0 0 0 8 8.667h1.333a.667.667 0 0 0 0-1.333h-.666V6A.667.667 0 0 0 8 5.333"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })